<template>

    <v-row justify="center">
        <v-dialog v-model="dialog" persistent :max-width="modalW" >
            <v-card>
                <v-card-title class="head_dialog d-flex align-center justify-space-between">
                    <p class="mb-0">{{modalTitle}}</p>
                    <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-form ref="form" v-model="formValid" onSubmit="return false;">
                    <!-- Modificar aportación -->
                    <v-card-text class="modal_text d-flex flex-column pl-6 pr-6" v-if="type === 'aportacion'">
                        <p class="mb-0">Modifica la aportación de dinero que harás a la Compra *</p>
                        <v-row>
                            <v-col cols="12" v-if="['habitual','compra_vivienda_100','2avivienda','autopromocion','cambio_vivienda'].includes(this.preScoring.Vivienda.tipo_vivienda)">
                                <v-currency-field
                                    color="var(--helloteca-main)"
                                    v-model="preScoring.Titulares.total_dinero_ahorrado"
                                    :rules="[...ruleRequired]"
                                    :min="0"
                                    :max="100000000"
                                    append-icon="mdi-currency-eur"
                                    persistent-hint
                                    outlined
                                ></v-currency-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <!-- Añadir titular -->
                    <v-card-text class="modal_text d-flex flex-column pl-6 pr-6" v-if="type === 'owner'">
                        <v-row v-for="(owner,i) in owners" :key="i" class="pt-5">
                            <div v-if="i>0">
                            <v-row>                            
                                <v-col cols="12 d-flex justify-start"><h2 class="mb-3">Titular {{i+1}}</h2></v-col>
                                <v-col cols=12 sm=6 v-if="i==0">
                                        <v-text-field
                                            label="Nombre completo *"
                                            v-model="owner.nombre_completo"
                                            :rules="[...ruleRequired]"
                                            outlined
                                            color="var(--helloteca-main)"
                                            dense
                                        ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="i==0">
                                    <v-text-field
                                        label="NIF - NIE *"
                                        v-model="owner.nif_nie"
                                        :rules="[...ruleRequired,...ruleCIF]"
                                        outlined
                                        color="var(--helloteca-main)"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="i!=0">
                                        <v-text-field
                                            label="Nombre completo"
                                            v-model="owner.nombre_completo"
                                            outlined
                                            color="var(--helloteca-main)"
                                            dense
                                        ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="i!=0">
                                    <v-text-field
                                        label="NIF - NIE"
                                        v-model="owner.nif_nie"
                                        :rules="[...ruleCIF]"
                                        outlined
                                        color="var(--helloteca-main)"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols=12 sm=6>
                                    <InputCalendar 
                                        :model="owner.nacimiento"
                                        label="Fecha de nacimiento *"
                                        outlined
                                        @setDate="(payload)=>{
                                            SET_OWNER_BIRTHDATE({date:payload,owner:i});
                                        }"
                                        required=true
                                        :max="getBirthdateDateMax()"
                                        :min="getBirthdateDateMin()"
                                        :showInitial="getBirthdateDateMax()"
                                        sourceFormat="AAAA/MM/DD"
                                        dense
                                    ></InputCalendar>
                                </v-col>
                                <v-col cols=12 sm=6>
                                    <v-select 
                                        label="Contrato del Titular *"
                                        outlined
                                        v-model="owner.contrato"
                                        :items="commonVars.contractTypes"
                                        :rules="[...ruleRequired]"
                                        item-text="name"
                                        item-value="code"
                                        dense
                                    />
                                </v-col>
                                <v-col cols=12 sm=6 v-if="nominaVisible(owner.contrato)">
                                    <v-currency-field
                                        :label="nominaLabel(owner.contrato)"
                                        outlined
                                        v-model="owner.nomina"
                                        :rules="[...ruleRequired]"
                                        :min="0"
                                        :max="50000000"
                                        append-icon="mdi-currency-eur"
                                        :hint="nominaHint(owner.contrato)"
                                        persistent-hint
                                        dense
                                    ></v-currency-field>
                                </v-col>
                                <v-col cols=12 sm=6 v-if="pagasVisible(owner.contrato)">
                                    <v-select 
                                        label="Número de pagas"
                                        outlined
                                        v-model="owner.numero_pagas"
                                        :items="numero_pagas"
                                        item-text="text"
                                        item-value="value"
                                        dense
                                    ></v-select >
                                </v-col>
                                <v-col cols=12 sm=6 v-if="antiguedadVisible(owner.contrato)">
                                    <InputCalendar 
                                        :model="owner.antiguedad"
                                        :label="antiguedadLabel(owner.contrato)"
                                        outlined
                                        @setDate="(payload)=>{
                                            SET_OWNER_JOB_SENIORITY({date:payload, owner:i});
                                        }"
                                        :max="getJobDateMax()"
                                        sourceFormat="AAAA/MM/DD"
                                        required=true
                                        dense
                                    ></InputCalendar>
                                </v-col>
                                <v-col cols=12 sm=6>
                                    <v-currency-field
                                        label="Cuotas mensuales de otras deudas *"
                                        outlined
                                        v-model="owner.gastos"
                                        :rules="[...ruleRequired]"
                                        :min="0"
                                        :max="50000"
                                        append-icon="mdi-currency-eur"
                                        :hint="prestamoHint(i)"
                                        persistent-hint
                                        dense
                                    ></v-currency-field>
                                </v-col>
                            </v-row>
                            </div>
                                <v-col cols="12" class="d-flex">
                                    <v-btn class="mr-2 elevation-0 add-owner-btn" v-if="i<3" @click="ADD_OWNER" rounded dark color="var(--helloteca-main)"><v-icon small class="mr-2">mdi-account-plus</v-icon> Añadir titular</v-btn>
                                    <v-btn v-if="i>0" @click="DELETE_OWNER(i)" class="elevation-0 add-owner-btn remove" rounded dark color="#CC0000"><v-icon small class="mr-2">mdi-account-minus</v-icon>Eliminar titular</v-btn>
                                </v-col>
                            </v-row>
                    </v-card-text>
                    <!-- Deuda titular -->
                    <v-card-text class="modal_text d-flex flex-column pl-6 pr-6" v-if="type === 'deuda'">
                        <v-row v-for="(owner,i) in owners" :key="i" class="pt-5">
                            
                            <v-row>                            
                                <v-col cols="12 d-flex justify-start"><h2 class="mb-3">Titular {{i+1}}</h2></v-col>
                                <v-col cols=12 sm=12>
                                    <v-currency-field
                                        label="Cuotas mensuales de otras deudas *"
                                        outlined
                                        v-model="owner.gastos"
                                        :rules="[...ruleRequired]"
                                        :min="0"
                                        :max="50000"
                                        append-icon="mdi-currency-eur"
                                        :hint="prestamoHint(i)"
                                        persistent-hint
                                        dense
                                    ></v-currency-field>
                                </v-col>
                            </v-row>
                                
                            </v-row>
                    </v-card-text>
                    <!-- Aportar aval -->
                    <v-card-text class="modal_text d-flex flex-column pl-6 pr-6" v-if="type === 'aval'">
                        
                        <v-checkbox
                            v-model="preScoring.Vivienda.avalista"
                            color="var(--helloteca-main)"
                            :false-value=0
                            :true-value=1
                        >
                            <template v-slot:label>
                                <div style="font-size: 1.1rem; font-weight:700">Sí, tengo aval</div>
                            </template>
                        </v-checkbox>
                                
                        <v-row id="avalista_block" v-if="preScoring.Vivienda.avalista === 1">
                            <v-col cols="12" class="mb-4">
                                <p class="mb-0">Un aval es una propiedad sin cargas (propia o familiar) que pueda aportarse como garantía de la hipoteca, para poder financiar un % mayor.</p>
                            </v-col>
                            <v-col cols="6" class="pb-0">
                                <v-select 
                                    label="¿Quien te avalará? *"
                                    v-model="preScoring.Avales.avalista_tipo"
                                    :items="guarantors"
                                    :rules="[...ruleRequired]"
                                    item-text="text"
                                    item-value="value"
                                    color="var(--helloteca-main)"
                                    outlined
                                />
                            </v-col>
                            <v-col cols="6" class="pb-0">
                                <v-currency-field
                                    label="¿Qué valor tiene la vivienda de tus avalistas? *"
                                    v-model="preScoring.Avales.avalista_valor_vivienda"                                   
                                    :rules="[...ruleMin10000,...ruleMax100M]"
                                    append-icon="mdi-currency-eur"
                                    hint="Introduce aquí, el valor aproximado de mercado de la vivienda"
                                    persistent-hint
                                    color="var(--helloteca-main)"
                                    outlined
                                ></v-currency-field>
                            </v-col>
                            <v-col cols="6" class="pb-0">
                                <v-select 
                                    label="¿Tiene hipoteca la vivienda? *"
                                    v-model="preScoring.Avales.avalista_hipoteca"
                                    :items="[{text:'Si', value:1},{text:'No', value:0}]"
                                    :rules="[...ruleRequiredWith0]"
                                    item-text="text"
                                    item-value="value"
                                    color="var(--helloteca-main)"
                                    outlined
                                />
                            </v-col>
                            
                            <v-col cols="6" class="pb-0" v-if="preScoring.Avales.avalista_hipoteca === 1">
                                <v-currency-field
                                    label="Capital pendiente de la hipoteca *"
                                    v-model="preScoring.Avales.avalista_hipoteca_pendiente"
                                    :rules="[...ruleRequired]"
                                    :min="0"
                                    :max="100000000"
                                    append-icon="mdi-currency-eur"
                                    hint="Si no lo conoces exactamente no importa, introduce un valor aproximado"
                                    persistent-hint
                                    color="var(--helloteca-main)"
                                    outlined
                                ></v-currency-field>
                            </v-col>
                        </v-row> 
                    </v-card-text>
                    <!-- Modificar valor de compra -->
                    <v-card-text class="modal_text d-flex flex-column pl-6 pr-6" v-if="type === 'amount_requested'">
                        <p class="mb-0">Modificar el valor de compra *</p>
                        <v-row>
                            <v-col cols="12">
                                <v-currency-field
                                    color="var(--helloteca-main)"
                                    v-model="preScoring.Vivienda.valor"
                                    :rules="[...ruleRequired]"
                                    :min="0"
                                    :max="100000000"
                                    append-icon="mdi-currency-eur"
                                    persistent-hint
                                    outlined
                                ></v-currency-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <!-- Aportar préstamo personal -->
                    <v-card-text class="d-flex flex-column justify-center pt-10 pb-10 pl-6 pr-6" v-if="type === 'personal'">
                        <p style="font-size: 1.2rem; font-weight:normal; mb-0">¿Estarías dispuesto a completar tu hipoteca con un préstamo personal y pagar dos cuotas?</p>
                        <v-radio-group v-model="preScoring.Vivienda.prestamo_personal" row required >
                            <v-radio
                                label="Si"
                                value="1"
                                color="var(--helloteca-main)"
                            ></v-radio>
                            <v-radio
                                label="No"
                                value="0"
                                color="var(--helloteca-main)"
                            ></v-radio>
                        </v-radio-group>
                       
                        <v-textarea
                            label="Comentario"
                            placeholder='Detalla si ya tienes un préstamo personal preconcedido'
                            v-model="preScoring.Vivienda.observaciones"
                            outlined
                            dense
                        ></v-textarea>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="modal_actions d-flex justify-end align-center pt-2">
                        <v-alert class="mb-0" prominent text dense color="error" v-if="preScoring.Vivienda.prestamo_personal === 'no'">
                                <v-icon color="error" class="mr-2">mdi-alert</v-icon> No podremos tramitar tu operación
                        </v-alert>
                        <v-spacer></v-spacer>
                        <v-btn elevation=0 class="confirm_button" @click="send">Guardar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
  </v-row>
</template>
  
<script>
    import { mapState, mapMutations } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin';
    import InputCalendar from '../../components/InputCalendar';

    export default {
        mixins: [rulesMixin],
        data() {
            return {
                formValid: false,
                legal: false
            }
        },
        props:['button', 'dialog', 'type'],
        components:{
            InputCalendar
        },
        methods: {
            ...mapMutations([
                'UPDATE_PRESCORING_DATA',
                'FREEZE_STATE',
                'BACK_TO_FREEZE_STATE',                
                'ADD_OWNER',
                'SET_OWNER_BIRTHDATE',                
                'SET_OWNER_JOB_SENIORITY',                
                'DELETE_OWNER',
            ]),
            close(){
                this.BACK_TO_FREEZE_STATE();
                this.$emit('close');
            },
            send(){
                if(this.$refs.form.validate()){
                    this.$emit('send', this.type);
                }
            },
             getBirthdateDateMax(){
                let date = new Date();
                return String(date.getFullYear()-18+'-'+String("0" + (date.getMonth() + 1)).slice(-2)+'-'+String("0" + date.getDate()).slice(-2));
            },
            getBirthdateDateMin(){
                let date = new Date();
                return String(date.getFullYear()-70+'-'+String("0" + (date.getMonth() + 1)).slice(-2)+'-'+String("0" + date.getDate()).slice(-2));
            },
            getJobDateMax(){
                let date = new Date();
                return String(date.getFullYear()+'-'+String("0" + (date.getMonth() + 1)).slice(-2)+'-'+String("0" + date.getDate()).slice(-2));
            },
            nominaLabel(contrato){ 
                let label = 'Nómina neta mensual *';
                switch (contrato) {
                    case 'autonomo':
                        label = 'Base Imponible General de la renta *';
                        break;
                    case 'rentista':
                        label = 'Ingresos mensuales netos *';
                        break;
                    case 'pensionista_jubilado':
                        label = 'Pensión neta mensual *';
                        break;
                }
                return label;
                
            },
            nominaHint(contrato){ 
                let label = null;
                switch (contrato) {
                    case 'autonomo':
                        label = '(ingreso neto anual)';
                        break;
                }
                return label;
                
            },
            prestamoHint(owner){ 
                let label = 'Tienes que introducir la suma de las cuotas mensuales de cualquier tipo de préstamo si tienes, como hipoteca/s, préstamos personales, coches, etc.';
                if(owner > 0){
                    label='Introducir sólo aquellas deudas distintas a los titulares anteriores';
                }
                return label;
                
            },
            antiguedadLabel(contrato){ 
                let label = 'Antigüedad del contrato *';
                switch (contrato) {
                    case 'autonomo':
                        label = 'Fecha de alta *';
                        break;
                }
                return label;
                
            },
            nominaVisible(contrato){
                let visible = true;
                switch (contrato) {
                    case 'siningresos':
                    case 'tuslabores':
                    case 'otro':
                        visible = false;
                        break;
                }
                return visible;
            },
            pagasVisible(contrato){
                let visible = true;
                switch (contrato) {
                    case 'autonomo':
                    case 'siningresos':
                    case 'tuslabores':
                    case 'rentista':
                    case 'pensionista_jubilado':
                    case 'otro':
                        visible = false;
                        break;
                }
                return visible;
            },
            antiguedadVisible(contrato){
                let visible = true;
                switch (contrato) {
                    case 'rentista':
                    case 'pensionista_jubilado':
                    case 'siningresos':
                    case 'tuslabores':
                    case 'otro':
                        visible = false;
                        break;
                }
                return visible;
            },
        },  
        computed: {
            ...mapState([
                'preScoring',
                'guarantors',
                'owners',
                'numero_pagas',                
                'commonVars',
            ]),
            modalTitle(){
                let title = '';

                switch (this.type) {
                    case 'aportacion':
                        title = 'Modificar aportación';
                        break;
                    case 'aval':
                        title = 'Aportar aval';
                        break;
                    case 'personal':
                        title = 'Complementar con un préstamo personal';
                        break;
                    case 'owner':
                        title = 'Añadir nuevo titular';
                        break;
                    case 'deuda':
                        title = 'Modificar deudas';
                        break;
                    case 'amount_requested':
                        title = 'Modificar valor de compra';
                        break;
                }
                return title;
            },
            modalW(){
                let w = 500;

                switch (this.type) {
                    case 'aval':
                        w = 700;
                        break;
                }
                return w;
            }
        },
        mounted(){
            console.log("preScoring.Vivienda.prestamo_personal",this.preScoring.Vivienda.prestamo_personal);
            console.log("preScoring.Vivienda.prestamo_personal",this.preScoring.Vivienda.observaciones);
        }

    }
</script>

<style lang="scss" scoped>
    .head_dialog{
        padding: 10px 30px !important;
        background: var(--helloteca-main);
        color: #FFF;
    }
    .def_button{
        width: 100%;
        border: 2px solid transparent;
        padding: 5px 20px;
        box-sizing: border-box;
        border-radius: 50px;
        min-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .headline{
        padding: 15px 30px 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
    }
    .hrtitle{
        font-family: 'Fredoka One';
        font-size: 1.7rem;
        line-height: 2rem;
        text-align: center;
        color: var(--helloteca-main);
        margin-bottom: 15px;
        word-break: initial;
    }
    .modal_text{
        p{
            margin: 0 0 20px;
            color: #333;
            font-size: 1rem;
            line-height: 1.2rem;
        }
    }
    .modal_actions{
        padding: 10px !important;
    }
    .confirm_button{
        font-family: 'montserrat';
        font-size: .9rem;
        font-weight: bold;
        width: auto;
        border: 2px solid var(--helloteca-main);
        padding: 5px 20px;
        box-sizing: border-box;
        border-radius: 5px;
        min-height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFF;
        color: var(--helloteca-main);
        transition: all .3s;
        &:hover{
            transition: all .3s;
            background: var(--helloteca-main);
            color: #FFF;
        }
    }
    .legal_wrapper{
        .v-input{
            margin-top: 0;
        }
        label{
            margin: 0;
            color: #607D8B;
            font-weight: bold;
            font-size: .8rem;
            line-height: 1.2rem;
            a{
                color: var(--helloteca-main);
            }
        }
    }
</style>